import React, { useMemo } from 'react';
import styled from 'styled-components';
import {
  setHighlightedProductAdder,
  resetSteps,
  productPackageSelector,
  productPackageStatusSelector,
} from '@src/features/product';
import {
  useAppSelector,
  useAppDispatch,
  useWidgetParam,
  useWidgetLocalParams,
  useWidgetsTheme,
  useTranslate,
} from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { GradientButton } from '@src/components/reusable';
import { track } from '@src/services/analytics';
import usePackageIdParam from '@src/hooks/usePackageIdParam';

const ProductPackageAdderButton = () => {
  const id = useWidgetId();
  const { i18n } = useTranslate();
  const dispatch = useAppDispatch();
  const localParams = useWidgetLocalParams();

  const packageId = usePackageIdParam();
  const productPackage = useAppSelector(productPackageSelector(packageId!));
  const status = useAppSelector(productPackageStatusSelector(packageId!));

  const actionColor = useWidgetsTheme('actionColor');
  const productCtaText = useWidgetParam('product-cta-text');

  const handleButtonClick = () => {
    track('productPackagePageBuyClick', {
      packageId,
      productPackageName: productPackage?.name,
    });

    dispatch(resetSteps(id));
    dispatch(setHighlightedProductAdder(id, localParams));
  };

  const buttonText = useMemo(
    () => (productCtaText ? productCtaText : i18n('adder_purchaseButton')),
    [productCtaText, i18n],
  );

  return (
    <ButtonContainer>
      <GradientButton actionColor={actionColor} onClick={handleButtonClick} disabled={!productPackage}>
        {status !== 'loading' && productPackage ? buttonText : i18n('base_loading')}
      </GradientButton>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  max-width: 300px;
`;

export default ProductPackageAdderButton;
